import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { useNavigate, useParams } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import { API_URL } from "../../../../constants/index";
import {
  GetServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import { toast } from "react-toastify";
import moment from "moment";
import * as Yup from "yup";
import { FaSpinner } from "react-icons/fa";

const ExpenseAdvanceEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Expense Advance"));
  }, []);

  const initialData = {
    TXNDate: "",
    ProjectID: "",
    EmployeeID: "",
    AdvanceAmount: "",
    CashAmount: "",
    CardAmount: "",
    CardNumber: "",
    CurrencyID: "",
    ExchangeRate: "",
    Remark: "",
  };
  const [formData, setFormData] = useState(initialData);
  console.log("formData",formData);

  const [projectOption, setProjectOption] = useState([]);
  const [currencyOption, setCurrencyOption] = useState([]);
  const [employeeOpt, setEmployeeOpt] = useState([]);
  const [exchangeRate, setExchangeRate] = useState("");
  const [advanceAmount, setAdvanceAmount] = useState("");
  const [convertedAmount, setConvertedAmount] = useState(0);
  const [enteredAmount, setEnteredAmount] = useState(0);
  const [isErrorShown, setIsErrorShown] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showCardNumber, setShowCardNumber] = useState(false);

  const [cashAmount, setCashAmount] = useState(0);
  const [cardAmount, setCardAmount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [errors, setErrors] = useState([]);
  console.log("errors",errors);
  
  const [currencyCode, setCurrencyCode] = useState();

  useEffect(() => {
    if (id) {
      fetchAdvanceExpenseShow(id);
    }
  }, []);

  const fetchAdvanceExpenseShow = async (id) => {
    const response = await GetServiceCaller(
      `${API_URL}payroll/reimbursements/advance/${id}`
    );
    if (response?.status === 200) {
      const fetchData = response?.data?.data;
      const formDataEdit = {
        ID: fetchData?.ID,
        TXNDate: moment(fetchData?.TXNDate).format("DD-MMM-YYYY"),
        CardNumber: fetchData?.CardNumber,
        ProjectID: fetchData?.ProjectID,
        EmployeeID: fetchData?.EmployeeID,
        CurrencyID: fetchData?.CurrencyID,
        ExchangeRate: fetchData?.ExchangeRate,
        AdvanceAmount: fetchData?.AdvanceAmount,
        CashAmount: fetchData?.CashAmount,
        CardAmount: fetchData?.CardAmount,
        Remark: fetchData?.Remark,
      };
      setFormData(formDataEdit);
      setEnteredAmount(fetchData?.CardAmount);
      setAdvanceAmount(fetchData?.AdvanceAmount);

      if (fetchData?.CardAmount > 0) {
        setShowCardNumber(true);
      } else {
        setShowCardNumber(false);
      }

      setPageLoading(false);
    } else {
      console.error(
        "Failed to fetch model masters. Server responded with status:",
        response.status
      );
    }
  };

  const fetchExpenseAdvance = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/reimbursements/advance`
      );
      if (response.status === 200) {
        // const projectList = response?.data?.projectList;
        // const projectOpt = projectList.map((item) => ({
        //   value: item.value,
        //   label: item.text,
        // }));
        // setProjectOption(projectOpt);
        // Employee List
        const EmployeeList = response?.data?.employeelist;
        const employeeOpt = EmployeeList.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setEmployeeOpt(employeeOpt);
        // Currency List
        const currency = response?.data?.currencies;
        const currecnyOpt = currency.map((item) => ({
          value: item.value,
          label: item.text,
        }));
        setCurrencyOption(currecnyOpt);
      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  };

  useEffect(() => {
    fetchExpenseAdvance();
  }, []);

  const handleProject = async (selectedOption, name) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };
      validateField(name, updatedData);
      return updatedData;
    });
  };

  useEffect(() => {
    if (formData?.EmployeeID != "") {
      fetchProjectDetail(formData.EmployeeID);
    }
    if (formData?.CurrencyID) {
      fetchCurrencyRate(formData?.CurrencyID);
    }
  }, [formData.EmployeeID, formData?.CurrencyID]);

  const fetchProjectDetail = async (id) => {
    try {
      // Construct the API URL with query parameters
      const url = `${API_URL}payroll/reimbursements/fetch-project-list?employeeID=${id}`;
      const response = await GetServiceCaller(url);

      // Project List
      const projectList = response?.data?.projectList;
      const projectOpt = projectList.map((item) => ({
        value: item.value,
        label: item.text,
      }));
      setProjectOption(projectOpt);
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const fetchCurrencyRate = async (currencyID) => {
    try {
      // Construct the API URL
      const url = `${API_URL}payroll/reimbursements/get-currency-exchange-rate?CurrencyID=${currencyID}`;
      const response = await GetServiceCaller(url);
      // Currency Rate
      const rate = response?.data?.Currency[0]?.ExchangeRate;
      const code = response?.data?.Currency[0]?.Code;
      setCurrencyCode(code);
      if (rate) {
        setExchangeRate(rate);
        setFormData((prevState) => ({
          ...prevState,
          ExchangeRate: rate,
        }));
      }
    } catch (error) {
      console.error("Error calling API:", error);
    }
  };

  const remainingAmount = advanceAmount - enteredAmount;
  const total = parseFloat(remainingAmount) + parseFloat(enteredAmount);

  const handleAmountChange = (e) => {
    const enteredValue = parseFloat(e.target.value) || 0.0;
    setEnteredAmount(enteredValue);

    setFormData((prevFormData) => ({
        ...prevFormData,
        CardAmount: enteredValue,
    }));

    // This will trigger a re-render
    setShowCardNumber(enteredValue > 0);
};

// Add this useEffect
useEffect(() => {
    if (showCardNumber !== null) { // Only validate after first render
        validateField('CardNumber', formData);
    }
}, [showCardNumber, formData.CardNumber]); // Run when these values change
  useEffect(() => {
    if (exchangeRate) {
      if (advanceAmount) {
        setConvertedAmount(
          parseFloat(advanceAmount) * parseFloat(exchangeRate)
        );
      } else {
        setConvertedAmount(0);
      }

      if (remainingAmount) {
        setCashAmount(parseFloat(remainingAmount) * parseFloat(exchangeRate));
        setFormData((prevData) => ({
          ...prevData,
          CashAmount: remainingAmount,
        }));
      } else {
        setCashAmount(0);
      }

      if (enteredAmount) {
        setCardAmount(parseFloat(enteredAmount) * parseFloat(exchangeRate));
      } else {
        setCardAmount(0);
      }

      if (total) {
        setTotalAmount(parseFloat(total) * parseFloat(exchangeRate));
      } else {
        setTotalAmount(0);
      }
    } else {
      // If exchangeRate is invalid, set all amounts to 0
      setConvertedAmount(0);
      setCashAmount(0);
      setCardAmount(0);
      setTotalAmount(0);
    }
  }, [advanceAmount, remainingAmount, enteredAmount, total, exchangeRate]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const schema = Yup.object().shape({
    ProjectID: Yup.string().required("Project is required"),
    AdvanceAmount: Yup.number()
      .typeError("Advance Amount is required")
      .required("Advance Amount is required")
      .nullable(),
       CardNumber: showCardNumber
            ? Yup.string()
                .matches(/^\d{16}$/, "Card No Should be in 16 digits")
                .required("Card No is required")
                .nullable()
            : Yup.mixed().notRequired(),
  });
  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [fieldName]: err.message,
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const updatedFormData = {
      ...formData,
      AdvanceAmount: formData?.AdvanceAmount || "",
      CashAmount: formData?.CashAmount || "",
      // CardAmount: formData?.CardAmount || "",
      CardAmount:  formData?.CardAmount == 0 ? "" : formData?.CardAmount || "",
      // CardNumber: showCardNumber
    };

    try {
      await schema.validate(formData, { abortEarly: false });
      setErrors({});
      const response = await PostFormServiceCaller(
        `${API_URL}payroll/reimbursements/advance/${id}`,
        updatedFormData,
        "put"
      );

      // Check if the response is successful (status code 200)
      if (response.status === 200) {
        // Display a success toast message
        toast.success("Form Update successfully!");

        // Optional: Reset form data if needed
        setFormData({}); // Reset form state, if applicable
        setTimeout(() => {
          navigate("/expense-advance");
        }, 2000);
        setLoading(false);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        console.error("Validation Error:", error);
        const validationErrors = {};
        error.inner.forEach((err) => {
          validationErrors[err.path] = err.message;
        });
        setErrors(validationErrors);
      } else {
        console.error("Unexpected Error:", error);
        // toast.error(
        //   error.response?.data?.message ||
        //     "You can select Indian currency and one foreign currency, but no more than two distinct currencies"
        // );
      }
    }
  };

  const handleCancel = () => {
    navigate("/expense-advance");
  };

  const handleSelect = async (selectedOption, name) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: selectedOption.value };

      // Trigger validation for the specific field after updating
      validateField(name, selectedOption.value);

      return updatedData;
    });

    // Clear the error message after selection
    setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
  };

  if (pageLoading) {
    return (
      <>
        <p class="position-absolute top-50 start-50 translate-middle text-center">
          <FaSpinner class="spinner" />
        </p>
      </>
    );
  } else {
    return (
      <>
        <div className="container-fluid" id="skill_section">
          <div className="container-fluid" id="skill-table-area">
            <div className="row p-2">
            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-md-12">
                  <div className="row">
                    <div className="col-md-5">
                      <div className="row">
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="Code" class="form-label">
                              Date<span className="required">*</span>
                            </label>
                            <CustomDatePicker
                              handleChange={handleChange}
                              value={formData.TXNDate}
                              name="TXNDate"
                              id="TXNDate"
                              className="form-control"
                              placeholderText="DD-MM-YYYY"
                              maxDate={new Date()}
                            />
                          </div>
                        </div>

                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="Code" class="form-label">
                              Employee<span className="required">*</span>
                            </label>
                            <div
                              title={
                                formData?.EmployeeID
                                  ? employeeOpt.find(
                                      (o) => o.value === formData.EmployeeID
                                    )?.label
                                  : ""
                              }
                            >
                              <Select
                                name="EmployeeID"
                                value={employeeOpt?.find(
                                  (o) => o.value === formData?.EmployeeID
                                )}
                                className={` ${
                                  errors.EmployeeID ? "is-invalid" : ""
                                }`}
                                options={[
                                  { value: null, label: "Select" },
                                  ...employeeOpt,
                                ]}
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                            </div>
                            {errors.EmployeeID && (
                              <div className="error">{errors.EmployeeID}</div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div>
                            <label for="Code" class="form-label">
                              Project<span className="required">*</span>
                            </label>
                            <div
                              title={
                                formData?.ProjectID
                                  ? projectOption.find(
                                      (o) => o.value === formData.ProjectID
                                    )?.label
                                  : ""
                              }
                            >
                              <Select
                                value={projectOption?.find(
                                  (o) => o.value === formData?.ProjectID
                                )}
                                className={` ${
                                  errors.ProjectID ? "is-invalid" : ""
                                }`}
                                options={[
                                  { value: null, label: "Select" },
                                  ...projectOption,
                                ]}
                                name="ProjectID"
                                onChange={(selectedOption, action) =>
                                  handleSelect(selectedOption, action.name)
                                }
                              />
                            </div>
                            {errors.ProjectID && (
                              <div className="error">{errors.ProjectID}</div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="Code" class="form-label">
                              Currency<span className="required">*</span>
                            </label>
                            <Select
                              options={[
                                { value: null, label: "Select" },
                                ...currencyOption,
                              ]}
                              value={currencyOption?.find(
                                (o) => o.value === formData?.CurrencyID
                              )}
                              name="CurrencyID"
                              onChange={(selectedOption, action) =>
                                handleSelect(selectedOption, action.name)
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="Code" class="form-label">
                              Exchange Rate<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control text-end"
                              id="Name"
                              aria-describedby="Name"
                              name="Name"
                              value={exchangeRate}
                              placeholder="Exchange Rate"
                              onChange={(e) => setExchangeRate(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label for="Code" class="form-label">
                              Remarks
                            </label>
                            <textarea
                              type="text"
                              className="form-control"
                              id="Remark"
                              aria-describedby="Remark"
                              name="Remark"
                              placeholder="Remark"
                              value={formData.Remark}
                              onChange={(e) => {
                                const value = e.target.value;
                                setFormData((prevState) => ({
                                  ...prevState,
                                  Remark: value,
                                }));
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-1 d-flex justify-content-center align-items-center">
                      <div className="vertical-line"></div>
                    </div>
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="Code" class="form-label">
                              Advance Amount<span className="required">*</span>
                            </label>
                            <div>
                              <div className="d-flex gap-1 mb-2">
                                <div className="mt-1">{currencyCode}</div>
                                <input
                                  type="text"
                                  className={`form-control text-end ${
                                    errors.AdvanceAmount ? "is-invalid" : ""
                                  }`}
                                  placeholder="0.00"
                                  value={advanceAmount || ""}
                                  onChange={(e) => {
                                    const value = e.target.value;
                                    setAdvanceAmount(value);
                                    setFormData((prevState) => ({
                                      ...prevState,
                                      AdvanceAmount: value,
                                    }));
                                    if (errors.AdvanceAmount) {
                                      setErrors((prevErrors) => ({
                                        ...prevErrors,
                                        AdvanceAmount: "",
                                      }));
                                    }
                                  }}
                                />
                              </div>
                              <div className="ms-3">
                                {errors.AdvanceAmount && (
                                  <div className="error">
                                    {errors.AdvanceAmount}
                                  </div>
                                )}
                              </div>
                              <div className="d-flex gap-1">
                                <div className="mt-1">Rs.</div>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  placeholder="0.00"
                                  value={convertedAmount.toFixed(2)}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="mb-1">
                            <label for="Code" class="form-label">
                              Card Amount
                            </label>
                            <div>
                              <div className="d-flex gap-1 mb-2">
                                <div className="mt-1">{currencyCode}</div>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  placeholder="0.00"
                                  name="CardAmount"
                                  value={enteredAmount}
                                  onChange={handleAmountChange}
                                />
                              </div>

                              <div className="d-flex gap-1">
                                <div className="mt-1">Rs.</div>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  placeholder="0.00"
                                  value={cardAmount.toFixed(2)}
                                  disabled
                                />
                              </div>
                              {showCardNumber && (
                                <div className="d-flex gap-1 mt-2">
                                  <div className="mt-1 invisible">Rs.</div>
                                  <div className="col-11">
                                    <input
                                      type="text"
                                      name="CardNumber"
                                      id="CardNumber"
                                      className={`form-control me-2 ${
                                        errors.CardNumber ? "is-invalid" : ""
                                      }`}
                                      value={formData.CardNumber}
                                      placeholder="Enter Card No"
                                      onChange={handleChange}
                                    />
                                    {errors.CardNumber && (
                                      <div className="invalid-feedback">
                                        {errors.CardNumber}
                                      </div>
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="Code" class="form-label">
                              Cash Amount
                            </label>
                            <div>
                              <div className="d-flex gap-1 mb-2">
                                <div className="mt-1">{currencyCode}</div>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  placeholder="0.00"
                                  value={remainingAmount.toFixed(2) || ""}
                                  disabled
                                />
                              </div>

                              <div className="d-flex gap-1">
                                <div className="mt-1">Rs.</div>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  placeholder="0.00"
                                  disabled
                                  value={cashAmount.toFixed(2)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="mb-3">
                            <label for="Code" class="form-label">
                              Total
                            </label>
                            <div>
                              <div className="d-flex gap-1 mb-2">
                                <div className="mt-1">{currencyCode}</div>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  placeholder="0.00"
                                  value={total || ""}
                                  disabled
                                />
                              </div>

                              <div className="d-flex gap-1">
                                <div className="mt-1">Rs.</div>
                                <input
                                  type="text"
                                  className="form-control text-end"
                                  placeholder="0.00"
                                  value={totalAmount.toFixed(2)}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-end">
                <button className="cancel-btn me-2" onClick={handleCancel}>
                  Cancel
                </button>
                <button type="submit" className="custom-btn">
                  {/* {loading ? <FaSpinner class="sm-spinner" /> : "Submit"} */}
                  Submit
                </button>
              </div>
            </form>
          </div>
          </div>
        </div>
      </>
    );
  }
};

export default ExpenseAdvanceEdit;
